"use client";

import { forwardRef } from "react";
import PropTypes from "prop-types";
import shared from "./shared";
import styled from "styled-components";
import { textColorInverted, blue20, blue10, blue25, blue40, accentColorPrimary, setAppearanceConstantLocal } from "@churchofjesuschrist/eden-style-constants";
import { AppearanceInvert } from "@churchofjesuschrist/eden-appearance";

// TODO: The colors used by Primary buttons for hover/active do not shift by adjusting lightness like the Danger button does. If we want to use a single color with others that are derived, Unity/GVSG will need to adjust the colors used to reflect that direction.
import { jsx as _jsx } from "react/jsx-runtime";
const [buttonPrimaryHoverDef, buttonPrimaryHover] = setAppearanceConstantLocal("button-primary-hover", {
  light: blue25,
  dark: blue10,
  prefix: "eden"
});
const [buttonPrimaryActiveDef, buttonPrimaryActive] = setAppearanceConstantLocal("button-primary-active", {
  light: blue40,
  dark: blue20,
  prefix: "eden"
});
const Component = styled.button.withConfig({
  componentId: "sc-1lb7nf5-0"
})(["", ";", ";", ";background-color:", ";color:", ";@media (hover:hover){&:hover{background:", ";color:", ";}}&:active{background:", ";}&:is(a):visited:not(:active){color:", ";}"], shared, buttonPrimaryHoverDef, buttonPrimaryActiveDef, accentColorPrimary, textColorInverted, buttonPrimaryHover, textColorInverted, buttonPrimaryActive, textColorInverted);

/**
 * Primary buttons are used to indicate that an action is strongly recommended for a user to complete a specific task.
 */
const Primary = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    href,
    disabled,
    renderAs = disabled ? "button" : href ? "a" : "button",
    type = renderAs === "button" ? "button" : undefined,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(AppearanceInvert, {
    inverted: props.inverted,
    children: /*#__PURE__*/_jsx(Component, {
      ...props,
      ref: ref,
      type: type,
      href: href,
      disabled: disabled,
      as: renderAs,
      children: props.children
    })
  });
});
Primary.displayName = "Primary";
Primary.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,
  /** Whether to apply styles that help the button stand out on a dark background. (deprecated) */
  inverted: PropTypes.bool,
  /** Whether to apply smaller styles */
  small: PropTypes.bool,
  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes) or the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes). */
  type: PropTypes.string,
  /** If the button should expand to the full width of its parent */
  fullWidth: PropTypes.bool,
  /** If the button should be disabled */
  disabled: PropTypes.bool,
  /** The link that the button should navigate to on click */
  href: PropTypes.string,
  /** The HTML tag string or React component to render as.
   *
   * By default, if `href` is present and it is not `disabled`, it will render as an `<a>`. Otherwise it will default to `<button>`. */
  renderAs: PropTypes.elementType
};
export default Primary;